// React and Next.js imports
import type { GetStaticProps } from "next";

// Builder.io imports
import type { BasePageProps } from "@orlandohealth/build-kit";
import { GenericPage } from "@orlandohealth/build-kit";
import { GenericWrapper } from "@orlandohealth/build-kit";

const Page = GenericPage.createPage(GenericWrapper);

export const getStaticProps: GetStaticProps<BasePageProps> = async ({
    locale,
    defaultLocale,
}) => {
    const result = await GenericPage.getStaticProps(
        "/clinical-trials/find",
        locale,
        defaultLocale,
        "page"
    );
    return {
        ...result,
        props: {
            ...result.props,
            locale,
            defaultLocale,
        },
    };
};

export default Page;
